module.exports = __webpack_public_path__ + "images/emoji/u6709.962d2f4e613569f5b70b.png";